import "../../../static/js/loaders/jquery";

document.getElementById("apply-btn").addEventListener("click", function (event) {
    const applicationCode = this.getAttribute('data-applicationcode');
    const educationName = this.getAttribute('data-educationname');
    _paq.push(['trackEvent', 'Anmälan till utbildning', educationName, applicationCode]);
});
$(".occasion-box-body").on("show.bs.collapse", function () {
    $(this).closest(".occasio-box").addClass("expanded");
});

$(".occasion-box-body").on("hide.bs.collapse", function () {
    $(this).closest(".occasio-box").removeClass("expanded");
});
